/**
 * Offers various scopes and sets background and defaults in foreign stores
 *
 * User: herbert
 * Date: 3.11.15
 * Time: 10:00
 */

import Reflux from 'reflux';

export default Reflux.createActions({
	select: {},
	hover: {},
	/** clears current stored scope and calls steleActions.clear */
	clear: {}
});
